
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/application_photos/[index]",
      function () {
        return require("private-next-pages/inspiration/application_photos/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/application_photos/[index]"])
      });
    }
  